export default __webpack_public_path__ + "static/media/kh.ccda0a1b.svg";